<template>
  <div>
    <v-col class="px-2 pt-0">
      <v-row class="ma-0">
        <v-col cols="12" class="px-1 pb-1">
          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dDropzoneOptions" @vdropzone-files-added="uploadFile" :useCustomSlot="true" class="pa-1">
            <v-icon>mdi-cloud-upload-outline</v-icon>
            <p class="mb-1 fs16 font-weight-bold fcT220">{{$t('labels.dropUpload')}}</p>
            <p class="mb-0 fs14 fcT240">{{$t('labels.selectUpload')}}</p>
          </vue-dropzone>
        </v-col>
        <v-col v-if="dFiles" cols="12" class="uploadFilesContainer mb-5 pa-1">
          <v-card v-for="(item, index) in dFiles" :key="index" flat class="mb-2">
            <v-col cols="12" class="py-1 borderBottomAlt px-0">
              <v-row class="ma-0" align="center">
                <v-col cols="7" class="pa-1">
                  <v-text-field v-model="item.name" @keyup="item.name = item.name.toLowerCase()" :disabled="index != dEditName" color="datPrimary" hide-details class="pt-0"></v-text-field>
                  <span>
                    {{item.errMessage}}
                  </span>
                </v-col>
                <v-col v-if="dUploadingFiles == false && item.error == true" cols="auto" class="mx-auto">
                  <v-tooltip color="datSecondary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="datDeleteBtnIcon" v-bind="attrs" v-on="on">mdi-close-circle</v-icon>
                    </template>
                    <span>{{item.errMessage}}</span>
                  </v-tooltip>
                </v-col>
                <template v-else-if="dUploadingFiles == false">
                  <v-col cols="auto" class="pa-1 text-center ml-auto">
                    <v-btn v-if="dEditName !== index"  icon @click="dEditName = index">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn v-else  icon @click="dEditName = null">
                      <v-icon class="datOkBtnIcon">mdi-check</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" class="pa-1 text-center">
                    <v-icon v-if="dUploadingFiles == false  && item.uploaded == true" color="green">mdi-check-circle</v-icon>
                    <v-btn  icon @click="dFiles.splice(index,1)" v-else-if="dUploadingFiles == false">
                      <v-icon class="datDeleteBtnIcon">mdi-delete-outline</v-icon>
                    </v-btn>
                  </v-col>
                </template>
                <v-col v-else cols="auto" class="mx-auto">
                  <v-progress-circular indeterminate color="datPrimary" size="26"></v-progress-circular>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="6" v-if="dFiles" class="py-1">
          <p class="fs12 fcT240 mb-0">
            {{$t('labels.filesTotal')}}{{dFiles.length}}
          </p>
        </v-col>
        <v-col v-if="dFiles.length > 0" cols="4" class="py-0 text-right ml-auto">
          <v-btn depressed block :class="[dFiles.length < 1 ? 'datBtnDisabled' : 'datPrimaryBtn' ]" @click="fCloseModal">{{$t('btn.upload')}}</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

export default {
  mixins: [mxCanalDenuncias],  
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    pMaxUploads:{
      type: String,
      default: undefined
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },
    pFileName:{ 
      type: String,
      default: undefined
    },
    pExcludedFiles:{ 
      type: Array,
      default: () => []
    },
    pMaxFileSize:{ 
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      dUploadingFiles: false,
      dFiles: [],
      dDropzoneOptions: {
        autoProcessQueue: false,
        url: 'http://localhost',
        previewsContainer: false,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' }
      },
      dEditName: null,
    }
  },
  methods: {

    // 'Guarda' el fichero a memoria
    uploadFile (files) {

      // Controlamos que no se suban más ficheros de los permitidos
      if(this.pMaxUploads != null && Number(this.pMaxUploads) < (files.length + this.dFiles.length)){
        const errorObject =  {
          internalErrorCode: 10000,
          internalErrorText: 'maxSelectedFilesSurpassed',
          errorMsg: `${this.$t('datError.maxSurpassed')}: ${this.pMaxUploads}`
        }
        this.fSnackBarError2(errorObject, this.pShowSnackbar)
      }
      
      // Recorremos los ficheros añadidos
      Object.keys(files).forEach(key => {
        let file = files[key]
        let base64 = null
        // Controlamos la extensión del fichero (Signaturit solo admite pdf o doc) 
        // if(file.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
        //    file.type != 'application/msword' &&
        //    file.type != 'application/pdf'){
        //   const errorObject =  {
        //     internalErrorCode: 10001,
        //     internalErrorText: 'notAllowedExtension',
        //     errorMsg: this.$t('datError.notAllowedExtension')
        //   }
        //   this.fSnackBarError2(errorObject, this.pShowSnackbar)
        // }

        // Controlamos el tamaño del fichero  
        if (this.pMaxFileSize && ((file.size / 1048576) > this.pMaxFileSize)){
          const errorObject =  {
            internalErrorCode: 10002,
            internalErrorText: 'maxFileSizeSurpassed',
            errorMsg: `${this.$t('datError.maxFileSizeSurpassed')} ${this.pMaxFileSize} Mb`
          }
          this.fSnackBarError2(errorObject, this.pShowSnackbar)
        }

        // Si ha ido ok, guardamos el fichero en base64 en el array de ficheros del sobre
        else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (event) => {
            base64 = event.target.result
          }
          reader.onloadend = () => {
            // Controlamos que no haya dos ficheros con el mismo nombre
            let existsName = this.fExistsFileName(file)

            if (existsName){
              const errorObject =  {
                internalErrorCode: 10003,
                internalErrorText: 'fileNameExists',
                errorMsg: this.$t('datError.fileNameExists')
              }
              this.fSnackBarError2(errorObject, this.pShowSnackbar)
            }else{
              this.dFiles.push(this.fGenerateUploadItem(file, base64))
            }
          }
        }
      })
    },
    
    // Devuelve el objeto con los datos del fichero
    fGenerateUploadItem (file, base64) { 
    
      return {
        name: this.fFormatName(file.name),
        content: base64.split(',')[1],
        size: file.size,
        creationDate: Date.now(), // La fecha es solo para la tabla, en bbdd se guarda la de la bbdd
        newFile: 'S' // Identifica los ficheros nuevos para que el ws no vuelva a guardar lo que que ya haya en el array de ficheros 
      }
    },
    
    // Compara los nombres sin extensión del fichero a subir y el resto de ficheros subidos
    fExistsFileName(file){
      let result = this.dFiles.find( item => item.name === file.name)
      return result
    },

    fCloseModal(){
      this.$emit('close-modal', this.dFiles)
    },
    
    // Da formato al nombre del fichero
    fFormatName (name) {
      let finalName 

      if(this.pFileName){
        finalName = this.pFileName.toLowerCase()
      }else{
      finalName = name.toLowerCase()
      finalName = finalName.replaceAll(' ', '-')
      }
      return finalName
    }
  }
}
</script>